import React from 'react';
import { Link } from 'react-router-dom';
import './StandardButton.css';

/**
 * Standardized Button Component
 * Based on the three variants from the homepage:
 * 1. Primary - Solid blue background
 * 2. Secondary - Lighter blue background  
 * 3. Outline - Transparent with border
 */
const StandardButton = ({ 
  children, 
  variant = 'primary', 
  size = 'medium',
  to, 
  href, 
  onClick, 
  disabled = false,
  loading = false,
  className = '',
  style = {},
  ...props 
}) => {
  const baseClasses = `
    standard-button
    standard-button--${variant}
    standard-button--${size}
    ${disabled ? 'standard-button--disabled' : ''}
    ${loading ? 'standard-button--loading' : ''}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  const buttonContent = (
    <>
      {loading && (
        <div className="standard-button__spinner">
          <div className="spinner"></div>
        </div>
      )}
      <span className={loading ? 'opacity-0' : ''}>{children}</span>
    </>
  );

  const commonProps = {
    className: baseClasses,
    style,
    disabled: disabled || loading,
    ...props
  };

  // Render as Link if 'to' prop is provided
  if (to && !disabled && !loading) {
    return (
      <Link to={to} {...commonProps}>
        {buttonContent}
      </Link>
    );
  }

  // Render as anchor if 'href' prop is provided
  if (href && !disabled && !loading) {
    return (
      <a href={href} {...commonProps}>
        {buttonContent}
      </a>
    );
  }

  // Render as button
  return (
    <button onClick={onClick} {...commonProps}>
      {buttonContent}
    </button>
  );
};

// Convenience components for each variant
export const PrimaryButton = (props) => (
  <StandardButton variant="primary" {...props} />
);

export const SecondaryButton = (props) => (
  <StandardButton variant="secondary" {...props} />
);

export const OutlineButton = (props) => (
  <StandardButton variant="outline" {...props} />
);

export default StandardButton;
